module.exports = __webpack_public_path__ + "img/home-photo.68be8c70.jpg";